// Compatibility shim: maps the legacy `uuid/v4` subpath import to uuid v11's named export.
// uuid v11 removed subpath exports (./v1, ./v4, etc.) — all functions are now
// accessed from the main package entry point.
const { v4 } = require("uuid");
module.exports = v4;
module.exports.default = v4;
